<template>
  <div class="h-100-percentage">
    <div
      v-if="
        mounted &&
          !loading &&
          photo &&
          (!me || (me && Object.keys(info).length > 0))
      "
    >
      <v-row>
        <v-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2">
          <div v-if="me">
            <div v-if="info && photo">
              <Actions
                v-if="full"
                :me="me"
                :photo="photo"
                :info="info"
                :categories="categories"
                :dense="true"
                :show-tokens="true"
              />
              <div v-if="full">
                <v-expansion-panels
                  v-model="expansionPanels"
                  accordion
                  flat
                  hover
                  class="panel"
                >
                  <v-expansion-panel class="mb-0">
                    <v-expansion-panel-header expand-icon="fal fa-angle-down">
                      <div>
                        <v-icon small class="mr-3">
                          fal fa-info-circle
                        </v-icon>
                        Information
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Information :me="me" :photo="photo" :info="info" />
                    </v-expansion-panel-content>
                    <v-divider />
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header expand-icon="fal fa-angle-down">
                      <div>
                        <v-icon small class="mr-3">
                          fal fa-camera-retro
                        </v-icon>
                        EXIF data
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Exif :photo="photo" />
                    </v-expansion-panel-content>
                    <v-divider />
                  </v-expansion-panel>
                  <v-expansion-panel
                    v-if="
                      me &&
                        me.id !== photo.photographerId &&
                        (me.isAdmin || me.role === types.user.role.curator)
                    "
                  >
                    <v-expansion-panel-header expand-icon="fal fa-angle-down">
                      <div>
                        <v-icon small class="mr-3">
                          fal fa-user-secret
                        </v-icon>
                        Curator's notes
                        <v-icon
                          v-if="photo.hasCuratorNotes"
                          x-small
                          class="ml-2 error--text"
                        >
                          fas fa-circle
                        </v-icon>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <CuratorNotes :me="me" :photo="photo" />
                    </v-expansion-panel-content>
                    <v-divider />
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header expand-icon="fal fa-angle-down">
                      <div>
                        <v-icon small class="mr-3">
                          fal fa-gavel
                        </v-icon>
                        Curation
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <Curate
                        :me="me"
                        :photo="photo"
                        :info="info"
                        :full="full"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <Comments :me="me" :photo="photo" />
              </div>
              <div v-else>
                <Curate :me="me" :photo="photo" :info="info" :full="full" />
              </div>
            </div>
          </div>
          <div v-else>
            <div>
              <h3 class="text-h6 font-weight-bold">
                <v-icon medium class="mr-2">fa-sign-in-alt</v-icon>
                You need to log in to curate this photo.
              </h3>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-else class="h-100-percentage d-flex align-center">
      <div class="text-center w-100-percentage">
        <v-icon class="fa-spin">fal fa-spinner</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '@/components/photo/Actions.vue'
import Information from '@/components/account/curation/panels/Information.vue'
import Exif from '@/components/account/curation/panels/Exif.vue'
import CuratorNotes from '@/components/account/curation/panels/CuratorNotes.vue'
import Curate from '@/components/account/curation/panels/Curate.vue'
import Comments from '@/components/account/curation/panels/Comments.vue'
import types from '@/utils/types'

export default {
  name: 'CurationAsidePanel',
  components: {
    Actions,
    Information,
    Exif,
    CuratorNotes,
    Curate,
    Comments
  },
  props: {
    full: {
      type: Boolean,
      default: false
    },
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    },
    info: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      types,
      mounted: false,
      expansionPanels:
        this.me &&
        this.me.id !== this.photo.photographerId &&
        (this.me.isAdmin || this.me.role === types.user.role.curator)
          ? 3
          : 2
    }
  },
  mounted() {
    this.mounted = true
  }
}
</script>

<style scoped>
.panel {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px 4px 0 0;
}
</style>
